import React, { useEffect, useState } from 'react';
import { Link, useParams, useSearchParams } from 'react-router-dom';
import { BookOpen, Loader2 } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { PhotoBookBuyButtons } from '../components/PhotoBookPanel';

// Public sales/download page for one photo book: /photobook/:id (?t=download token from the purchase email).
export default function PhotoBookPage() {
  const { id } = useParams();
  const [params] = useSearchParams();
  const token = params.get('t') || '';
  const { getPhotoBook, mediaUrl } = useAuth();
  const [book, setBook] = useState(undefined);
  useEffect(() => { getPhotoBook(id, token).then(setBook).catch(() => setBook(null)); }, [id, token]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="max-w-4xl mx-auto px-4 py-10 fade-in" data-testid="photo-book-page">
      {book === undefined && <div className="py-16 text-center"><Loader2 className="animate-spin mx-auto" style={{ color: 'var(--navy)' }} /></div>}
      {book === null && <p className="text-sm px-3 py-2 rounded" style={{ background: '#fdecea', color: '#8a1f11' }} data-testid="photo-book-missing">This photo book is not available.</p>}
      {book && (
        <div className="grid md:grid-cols-[320px_1fr] gap-8 items-start">
          <div className="rounded-lg overflow-hidden shadow-lg border-4 border-white" style={{ background: 'var(--navy)' }}>
            {book.cover_url ? <img src={mediaUrl(book.cover_url)} alt="" className="w-full aspect-[3/4] object-cover" data-testid="photo-book-cover" /> : <div className="aspect-[3/4] flex items-center justify-center"><BookOpen size={64} style={{ color: 'var(--cream)' }} /></div>}
          </div>
          <div>
            <div className="text-xs uppercase tracking-widest mb-2" style={{ color: 'var(--navy)' }}>Photo book</div>
            <h1 className="font-title text-3xl md:text-4xl mb-2" style={{ color: 'var(--maroon)' }} data-testid="photo-book-title">{book.title || book.album}</h1>
            <p className="text-sm mb-1" style={{ color: 'var(--olive)' }} data-testid="photo-book-meta">{book.pages} A4 pages · {book.photo_count} photographs · from the “{book.album}” album</p>
            {book.description && <p className="text-[15px] my-4" style={{ color: 'var(--ink)' }} data-testid="photo-book-description">{book.description}</p>}
            <div className="my-5"><PhotoBookBuyButtons book={book} token={token} /></div>
            {book.can_download && token && <p className="text-xs" style={{ color: 'var(--olive)' }}>This link is your personal download key — keep it safe.</p>}
            {!book.can_download && <p className="text-xs" style={{ color: 'var(--olive)' }}>Payment is by secure card checkout. PDF buyers receive a download link by email; printed copies are professionally printed and posted to you.</p>}
            <Link to="/shop" className="inline-block mt-6 text-sm underline" style={{ color: 'var(--navy)' }} data-testid="photo-book-shop-link">Browse the shop</Link>
          </div>
        </div>
      )}
    </div>
  );
}
